import { Component, ViewEncapsulation, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';

@Component({
  selector: 'ds-quote-block',
  templateUrl: './quote-block.html',
  styleUrl: './quote-block.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [NgOptimizedImage],
})
export class QuoteBlockComponent {
  readonly quote = input.required<string>();
  readonly name = input.required<string>();
  readonly role = input.required<string>();
  readonly company = input<string>();
  readonly imageSrc = input<string>();
  readonly imageAlt = input<string>();
  readonly imageWidth = input<number>(0);
  readonly imageHeight = input<number>(0);
}
